import { Col, Row } from 'aui';
import type { Gutter } from 'aui/es/grid/row';
import isArray from 'lodash-es/isArray';
import isBoolean from 'lodash-es/isBoolean';
import isNumber from 'lodash-es/isNumber';
import isObject from 'lodash-es/isObject';
import isString from 'lodash-es/isString';
import type { MdComponentIndexProps } from '../type';
import { mapSpecChildrenFactory } from '../utils/mapSpecChildren';
import { MarkdownCol, validateColProps } from './Col';
// import { useRef } from 'react';
// import styles from './Tooltip.module.less';

type MarkdownRowProps = React.ComponentProps<typeof Row>;

function validateGutter(gutter: Gutter) {
  if (isNumber(gutter)) {
    return gutter;
  } else if (isObject(gutter)) {
    const keys = Object.keys(gutter) as (keyof typeof gutter)[];
    for (const key of keys) {
      if (!isNumber(gutter[key])) {
        return undefined;
      }
    }
  } else {
    return undefined;
  }
}

function validateProps(props: MarkdownRowProps) {
  const res = { ...props };
  if (!isString(res.align) && !isObject(res.align)) res.align = undefined;
  if (isArray(res.gutter)) {
    // if (res.gutter.length !== 2) {
    //   res.gutter = undefined;
    // } else {
    if (!validateGutter(res.gutter[0])) {
      res.gutter = undefined;
    } else if (!validateGutter(res.gutter[1])) {
      res.gutter = undefined;
    }
    // }
  } else if (!validateGutter(res.gutter)) {
    res.gutter = undefined;
  }
  if (!isString(res.justify) && !isObject(res.justify)) res.justify = undefined;
  if (!isBoolean(res.wrap)) res.wrap = undefined;
  return res;
}

const mapAcc = mapSpecChildrenFactory(MarkdownCol);

export function MarkdownRow(
  props: React.PropsWithChildren<MarkdownRowProps & MdComponentIndexProps>,
) {
  const colProps = mapAcc(props.children, (colProps, key, child) => {
    return {
      key: String(key),
      ...validateColProps(colProps),
      children: child ? <div className={'markdown-child-root'}>{child}</div> : null,
    } as typeof colProps;
  });
  return (
    <Row {...validateProps(props)} data-first={props['data-first']} data-last={props['data-last']}>
      {colProps.map((colProp) => (
        <Col {...colProp} />
      ))}
    </Row>
  );
}

MarkdownRow.attributes = ['align', 'gutter', 'justify', 'wrap', 'className', 'style'];
// MarkdownRow.inline = false;
MarkdownRow.displayName = 'MarkdownRow';
